var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrid12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 11,
    viewBox: "0 0 20 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.9 5.83997C1.9 4.12997 3.29 2.73997 5 2.73997H9V0.839966H5C2.24 0.839966 0 3.07997 0 5.83997C0 8.59997 2.24 10.84 5 10.84H9V8.93997H5C3.29 8.93997 1.9 7.54997 1.9 5.83997ZM6 6.83997H14V4.83997H6V6.83997ZM15 0.839966H11V2.73997H15C16.71 2.73997 18.1 4.12997 18.1 5.83997C18.1 7.54997 16.71 8.93997 15 8.93997H11V10.84H15C17.76 10.84 20 8.59997 20 5.83997C20 3.07997 17.76 0.839966 15 0.839966Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid12);
export default __webpack_public_path__ + "static/media/grid12.0ee7863249dcf3e1d4c87665e1d028d9.svg";
export { ForwardRef as ReactComponent };